import React, { useRef, useMemo } from 'react';
import { Doughnut } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  Colors,
} from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend, Colors);

interface Props {
  labels: string[];
  data: number[];
  height?: number;
}

const PieChart: React.FC<Props> = ({ labels, data, height = 240 }) => {
  const chartRef = useRef<ChartJS<'doughnut'> | null>(null);

  const chartData = useMemo(() => {
    return {
      labels: labels,
      datasets: [
        {
          data: data,
          borderWidth: 1,
          borderColor: [
            '#e53935',
            '#ffb300',
            '#c0ca33',
            '#7cb342',
            '#00897b',
            '#00acc1',
            '#42a5f5',
            '#7e57c2',
            '#5c6bc0',
            '#f4511e',
            '#fdd835',
            '#03a9f4',
          ],
          backgroundColor: [
            '#e57373',
            '#ffe082',
            '#e6ee9c',
            '#a5d6a7',
            '#4db6ac',
            '#4dd0e1',
            '#90caf9',
            '#b39ddb',
            '#9575cd',
            '#ff8a65',
            '#fff59d',
            '#81d4fa',
          ],
        },
      ],
    };
  }, [labels, data]);

  const options = {
    plugins: {
      legend: {
        position: 'bottom' as const,
        labels: {
          useBorderRadius: true,
          borderRadius: 50,
          pointStyle: 'circle',
          usePointStyle: true,
          boxWidth: 10,
        },
      },
      tooltip: {
        intersect: false,
        borderColor: '#ddd',
        borderWidth: 1,
        backgroundColor: '#ffffff',
        titleColor: '#4A5568',
        bodyColor: '#4A5568',
      },
    },
    maintainAspectRatio: false,
    responsive: true,
  };

  return (
    <div style={{ height }}>
      <Doughnut ref={chartRef} data={chartData} options={options} />
    </div>
  );
};

export default PieChart;
